import { compact } from '@erikdakoda/tool-set/ai-tools/compact';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(compact);
